// extracted by mini-css-extract-plugin
module.exports = {"main":"Signup_main__3IAuw","signin_btn":"Signup_signin_btn__IPJNW","create_btn":"Signup_create_btn__2lLnl"};